// extracted by mini-css-extract-plugin
module.exports = {"container-page-404":"Page404_container-page-404__1O0v_","errorNumber":"Page404_errorNumber__yDdss","errorText":"Page404_errorText__qCrpS"};